// extracted by mini-css-extract-plugin
export default {"row":"LicenseData_row__0rxye","buttonContainer":"LicenseData_buttonContainer__+XHfA"};